import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import Type, { Heading } from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';

import Image from '@nerdwallet/react-image';

const PressKitItem = ({ header, body, image, cta, url, evenRow }) => {
  const itemOrientation = evenRow
    ? 'press-kit__item--even'
    : 'press-kit__item--odd';
  const contentOrientation = evenRow
    ? 'press-kit__content--even'
    : 'press-kit__content--odd';
  const bodyHTML = () => ({ __html: body });
  const insertButton = cta ? (
    <Button className={classNames(['press-kit__item--btn'])} primary href={url}>
      {cta}
    </Button>
  ) : null;

  return (
    <div
      className={classNames([
        'press-kit__item',
        `${itemOrientation}`,
        classes('display-flex--wide'),
        classes('flex-direction-row--wide'),
        classes('align-items-center--wide'),
        classes('margin-bottom-5'),
      ])}
    >
      <Image
        src={image}
        alt={header}
        backgroundColor="transparent"
        className={classNames([
          'press-kit__image',
          classes('margin-horizontal-0'),
          classes('margin-top-0'),
          classes('margin-bottom-4'),
        ])}
        imageClassName="press-kit__item--image"
        naturalWidth={432}
        naturalHeight={372}
      />
      <div
        className={classNames([
          'press-kit__content',
          `${contentOrientation}`,
          classes('text-align-left--wide'),
          classes('padding-left-5--wide'),
          classes('margin-bottom-4--wide'),
        ])}
      >
        <Heading
          level={2}
          chronicle
          bold={false}
          className={classNames([
            'press-kit__item--header',
            classes('margin-bottom-2'),
          ])}
        >
          {header}
        </Heading>
        <Type
          className={classNames([
            'press-kit__item--body',
            classes('text-small'),
            classes('text-default--wide'),
            classes('margin-bottom-3'),
            classes('margin-bottom-4--wide'),
          ])}
          level="3"
          dangerouslySetInnerHTML={bodyHTML()}
        />
        {insertButton}
      </div>
    </div>
  );
};

PressKitItem.propTypes = {
  header: PropTypes.string,
  body: PropTypes.string,
  image: PropTypes.string,
  cta: PropTypes.string,
  url: PropTypes.string,
  evenRow: PropTypes.bool,
};

PressKitItem.displayName = 'PressKitItem';

export default PressKitItem;
